const womensBottoms = {
  0: "XXXS",
  2: "XXS",
  4: "XS",
  6: "S",
  8: "M",
  10: "L",
  12: "XL",
  14: "XL",
  16: "1X",
  18: "1X",
  20: "2X",
  22: "XXXS",
  23: "XXS",
  24: "XS",
  25: "XS",
  26: "S",
  27: "S",
  28: "M",
  29: "M",
  30: "L",
  31: "L",
  32: "XL",
  33: "XL",
  "16X": "1X",
  "18X": "1X",
  "20X": "2X",
  "22X": "2X",
  XXXS: "0",
  XXS: "2",
  XS: "4",
  S: "6",
  M: "8",
  L: "10",
  XL: "12-14",
  "1X": "16-18",
  "2X": "20"
};

const womensOuterwear = {
  0: "XXXS",
  2: "XXS",
  4: "XS",
  6: "S",
  8: "M",
  10: "L",
  12: "XL",
  14: "XL",
  16: "1X",
  18: "1X",
  20: "2X",
  22: "2X",
  XXXS: "0",
  XXS: "2",
  XS: "4",
  S: "6",
  M: "8",
  L: "10",
  XL: "12-14",
  "1X": "16-18",
  "2X": "20",
  "XS/S": "2-4",
  "M/L": "6-8",
  "XL/XXL": "10-14"
};

const mensBottoms = {
  26: "XXS",
  27: "XS",
  28: "XS",
  29: "S",
  30: "S",
  31: "M",
  32: "M",
  33: "L",
  34: "L",
  35: "XL",
  36: "XL",
  37: "XL",
  38: "XXL",
  39: "XXL",
  40: "XXL",
  42: "3XL",
  44: "3XL",
  46: "4XL",
  48: "5XL",
  50: "5XL",
  XXS: "26",
  XS: "27-28",
  S: "29-30",
  M: "31-32",
  L: "33-34",
  XL: "35-37",
  XXL: "38-40",
  XXXL: "42-44",
  "3XL": "42-44",
  "4XL": "46",
  "5XL": "48-50"
};

export const hybridSizingCategoriesMap = {
  "womens-leggings": womensBottoms,
  "womens-joggers": womensBottoms,
  "women-shorts": womensBottoms,
  "women-pants": womensBottoms,
  "womens-sweatpants": womensBottoms,
  "women-crops": womensBottoms,
  "womens-trousers": womensBottoms,
  "womens-outerwear": womensOuterwear,
  "men-pants": mensBottoms,
  "men-joggers": mensBottoms,
  "mens-trousers": mensBottoms
};
